import type { SavedViewPayload, ViewRows } from "./savedViewPayload";

function describeRows(rows: ViewRows): string[] {
  const parts: string[] = [];
  // Full and null impose no restriction, so a category or a hand-picked
  // metric narrows the selection rather than widening it — see
  // ``selectedMetrics``. Saying "All KPIs" alongside it would be a lie.
  const catalogue = rows.preset && rows.preset !== "Full" ? rows.preset : null;
  if (catalogue) parts.push(catalogue);
  if (rows.categories.length) {
    parts.push(
      catalogue ? `+${rows.categories.join(" +")}` : rows.categories.join(" + ")
    );
  } else if (!catalogue && !rows.metrics.length) {
    parts.push("All KPIs");
  }
  if (rows.metrics.length) parts.push(`${rows.metrics.length} picked`);
  if (rows.yearOffsets) parts.push("recent years");
  if (rows.sortBy !== "None") parts.push(rows.sortBy);
  return parts;
}

/**
 * One line naming everything a view will change, for the picker row.
 *
 * Derived from the payload rather than written per view, so a row can't
 * promise something the view no longer does — the picker's answer to "what
 * happens if I click this?".
 */
export function describeView(payload: SavedViewPayload): string {
  const parts: string[] = [];
  const shape = payload.dataShape;
  if (shape?.calendarView) parts.push(shape.calendarView);
  if (shape?.timePeriod) parts.push(shape.timePeriod);
  if (shape?.planningYear) parts.push(shape.planningYear);
  if (shape?.planBy) parts.push(shape.planBy);
  if (payload.rows) parts.push(...describeRows(payload.rows));
  return parts.join(" · ");
}
